import "../assets/index-7157aefa.css";
import c from "./NcButton.mjs";
import i from "./NcPopover.mjs";
import { t as a } from "../chunks/l10n-1b905a9a.mjs";
import { G as d } from "../chunks/GenColors-12ec1caa.mjs";
import { G as u } from "../chunks/GenRandomId-cb9ccebe.mjs";
import { A as p } from "../chunks/ArrowLeft-3779ba88.mjs";
import { C as f } from "../chunks/Check-2ea0a88a.mjs";
import { D as m } from "../chunks/DotsHorizontal-0ee7d901.mjs";
import { Chrome as _ } from "vue-color";
import { n as v } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
function h({ r: t, g: e, b: r }) {
  const o = (n) => n.toString(16).padStart(2, "0");
  return `#${o(t)}${o(e)}${o(r)}`;
}
const l = /^#([a-f0-9]{3}|[a-f0-9]{6})$/i, C = {
  name: "NcColorPicker",
  components: {
    ArrowLeft: p,
    Check: f,
    Chrome: _,
    DotsHorizontal: m,
    NcButton: c,
    NcPopover: i
  },
  props: {
    /**
     * A HEX color that represents the initial value of the picker
     */
    value: {
      type: String,
      required: !0
    },
    /**
     * Set to `true` to enable advanced fields including HEX, RGB, and HSL
     */
    advancedFields: {
      type: Boolean,
      default: !1
    },
    /**
     * Provide a custom array of colors to show.
     * Can be either an array of string hexadecimal colors,
     * or an array of object with a `color` property with hexadecimal color string,
     * and a `name` property for accessibility.
     *
     * @type {string[] | {color: string, name: string}[]}
     */
    palette: {
      type: Array,
      default: () => d(4).map((t) => ({ color: h(t), name: t.name })),
      validator: (t) => t.every(
        (e) => typeof e == "string" && l.test(e) || typeof e == "object" && e.color && l.test(e.color)
      )
    }
  },
  emits: [
    "submit",
    "close",
    "update:open",
    "update:value",
    "input"
  ],
  data() {
    return {
      currentColor: this.value,
      advanced: !1,
      ariaBack: a("Back"),
      ariaMore: a("More options")
    };
  },
  computed: {
    normalizedPalette() {
      return this.palette.map((t) => ({
        color: typeof t == "object" ? t.color : t,
        name: typeof t == "object" && t.name ? t.name : a("A color with a HEX value {hex}", { hex: t.color })
      }));
    },
    uid() {
      return u();
    }
  },
  watch: {
    value(t) {
      this.currentColor = t;
    }
  },
  methods: {
    t: a,
    /**
     * Submit a picked colour and close picker
     */
    handleConfirm() {
      this.$emit("submit", this.currentColor), this.handleClose(), this.advanced = !1;
    },
    handleClose() {
      this.$emit("close"), this.$emit("update:open", !1);
    },
    /**
     * Inner navigations
     */
    handleBack() {
      this.advanced = !1;
    },
    handleMoreSettings() {
      this.advanced = !0;
    },
    /**
     * Pick a colour
     *
     * @param {string} color the picked color
     */
    pickColor(t) {
      typeof t != "string" && (t = this.currentColor.hex), this.currentColor = t, this.$emit("update:value", t), this.$emit("input", t);
    }
  }
};
var k = function() {
  var e = this, r = e._self._c;
  return r("NcPopover", e._g(e._b({ on: { "apply-hide": e.handleClose }, scopedSlots: e._u([{ key: "trigger", fn: function() {
    return [e._t("default")];
  }, proxy: !0 }], null, !0) }, "NcPopover", e.$attrs, !1), e.$listeners), [r("div", { staticClass: "color-picker", class: { "color-picker--advanced-fields": e.advanced && e.advancedFields } }, [r("Transition", { attrs: { name: "slide", mode: "out-in" } }, [e.advanced ? e._e() : r("div", { staticClass: "color-picker__simple" }, e._l(e.normalizedPalette, function({ color: o, name: n }, s) {
    return r("label", { key: s, staticClass: "color-picker__simple-color-circle", class: { "color-picker__simple-color-circle--active": o === e.currentColor }, style: { backgroundColor: o } }, [o === e.currentColor ? r("Check", { attrs: { size: 20 } }) : e._e(), r("input", { staticClass: "hidden-visually", attrs: { type: "radio", "aria-label": n, name: `color-picker-${e.uid}` }, domProps: { checked: o === e.currentColor }, on: { click: function(g) {
      return e.pickColor(o);
    } } })], 1);
  }), 0), e.advanced ? r("Chrome", { staticClass: "color-picker__advanced", attrs: { "disable-alpha": !0, "disable-fields": !e.advancedFields }, on: { input: e.pickColor }, model: { value: e.currentColor, callback: function(o) {
    e.currentColor = o;
  }, expression: "currentColor" } }) : e._e()], 1), r("div", { staticClass: "color-picker__navigation" }, [e.advanced ? r("NcButton", { attrs: { type: "tertiary", "aria-label": e.ariaBack }, on: { click: e.handleBack }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [r("ArrowLeft", { attrs: { size: 20 } })];
  }, proxy: !0 }], null, !1, 1821202730) }) : e._e(), e.advanced ? e._e() : r("NcButton", { attrs: { type: "tertiary", "aria-label": e.ariaMore }, on: { click: e.handleMoreSettings }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [r("DotsHorizontal", { attrs: { size: 20 } })];
  }, proxy: !0 }], null, !1, 1056868794) }), e.advanced ? r("NcButton", { attrs: { type: "primary" }, on: { click: e.handleConfirm } }, [e._v(" " + e._s(e.t("Choose")) + " ")]) : e._e()], 1)], 1)]);
}, y = [], b = /* @__PURE__ */ v(
  C,
  k,
  y,
  !1,
  null,
  "b23899c8",
  null,
  null
);
const w = b.exports;
export {
  w as default
};
